if (!customElements.get('card-product-slider')) {
  class CardProductSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions =
        JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.requiresFetch = this.hasAttribute('data-url');
      this.parent = this.closest('[data-section-id]');

      this.sliderOptions = {
        a11y: false,
        threshold: 3,
        resistanceRatio: 0.72,

        slidesPerView: 1.15,
        spaceBetween: swiperOptions.spaceBetweenMobile || 12,

        allowTouchMove: true,
        watchOverflow: false,
        observer: true,
        observeParents: true,

        navigation: {
          nextEl: '.swiper-button--next',
          prevEl: '.swiper-button--prev'
        },

        breakpoints: {
          575: {
            slidesPerView: 2,
            spaceBetween: swiperOptions.spaceBetweenMobile || 12
          },

          750: {
            slidesPerView: 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 20
          },

          1100: {
            slidesPerView: 4,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 20
          }
        }
      };
    }

    connectedCallback() {
      if (this.requiresFetch) {
        this.fetchItems();
        return;
      }

      this.initSlider();
    }

    fetchItems() {
      if (!this.parent) throw new Error('Parent is missing');

      fetch(this.getAttribute('data-url'))
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const wrapper = html.querySelector('.swiper-wrapper');

          if (wrapper && wrapper.innerHTML.trim().length) {
            this.querySelector('.swiper-wrapper').innerHTML = wrapper.innerHTML;
            this.parent.classList.remove('hidden');
            this.initSlider();
          }
        })
        .catch(console.error);
    }

    initSlider(slider = this) {
      if (this.slider) return;

      this.slider = new Swiper(slider, this.sliderOptions);

      if (this.classList.contains('section-shop-the-look__slider')) return;

      this.slider.wrapperEl.setAttribute('aria-live', 'polite');
      this.slider.wrapperEl.id = `swiper-wrapper-${this.dataset.sectionId}`;

      this.slider.slides.forEach((slide, index) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute(
          'aria-label',
          `${index + 1} / ${this.slider.slides.length}`
        );
        slide.dataset.index = index;
      });

      [
        this.slider.navigation.prevEl,
        this.slider.navigation.nextEl
      ].forEach((button, index) => {
        if (!button) return;

        button.setAttribute(
          'aria-label',
          index ? 'Next slide' : 'Previous slide'
        );

        button.setAttribute(
          'aria-controls',
          this.slider.wrapperEl.id
        );
      });
    }
  }

  customElements.define('card-product-slider', CardProductSlider);
}

document.addEventListener('shopify:section:load', event => {
  const slider = event.target.querySelector('card-product-slider');

  if (slider) {
    slider.connectedCallback();
  }
});